import NoteRow from "./NoteRow";

export default function NoteTable({ notes, loading }) {
  if (loading) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <div className="h-5 w-32 bg-gray-100 rounded mb-4" />
        <div className="space-y-2">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-12 bg-gray-50 rounded-xl" />
          ))}
        </div>
      </div>
    );
  }

  if (!notes?.length) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-10 text-center text-gray-500 shadow-sm">
        No notes found.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      {/* Desktop table */}
      <div className="hidden md:block">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50/60">
            <tr>
              <Th>Title</Th>
              <Th>Short Title</Th>
              <Th>Status</Th>
              <Th>Created</Th>
              <Th className="text-right pr-6">Actions</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {notes.map((u) => <NoteRow key={u._id} note={u} />)}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <ul className="md:hidden divide-y divide-gray-100">
        {notes.map((u) => (
          <li key={u._id} className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-gray-900">{u.title}</div>
                <div className="text-sm text-gray-500">{u.shorttitle}</div>
              </div>
              <Status active={u.active} />
            </div>
            <div className="mt-2 text-sm text-gray-600">
              {Array.isArray(u.roles) ? u.roles.join(", ") : u.roles}
            </div>
            <div className="mt-3 flex justify-end gap-2">
              <Action note={u} type="edit" />
              <Action note={u} type="delete" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Th({ children, className = "" }) {
  return (
    <th className={`px-6 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 ${className}`}>
      {children}
    </th>
  );
}

function Status({ active }) {
  return active ? (
    <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span> Active
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
      <span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span> Disabled
    </span>
  );
}

function Action({ note, type }) {
  const base =
    "inline-flex items-center rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50";
  if (type === "edit") return <button className={base}>Edit</button>;
  if (type === "delete") return <button className={base}>Delete</button>;
  return null;
}
